import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuxiliaresModule } from '../../../auxiliares/auxiliares.module';
import { CodigosDispositivosService } from '../../../auxiliares/servicios/http/codigos-dispositivos.service';
import { HelperService } from '../../../auxiliares/servicios/helper.service';
import { LoginService } from '../../login/login.service';
import { LoadingService } from '../../../auxiliares/servicios/loading.service';

@Component({
  imports: [AuxiliaresModule],
  selector: 'app-clonador',
  templateUrl: './clonador.component.html',
  styleUrls: ['./clonador.component.scss'],
})
export class ClonadorComponent implements OnInit, OnDestroy {
  matDialogRef = inject<MatDialogRef<ClonadorComponent>>(MatDialogRef);
  private codigosService = inject(CodigosDispositivosService);
  private helper = inject(HelperService);
  loading = inject(LoadingService);
  data = inject<{
    idEntidad: string;
    entidad: string;
    // Nombre de lo que se clona (subtítulo del encabezado)
    nombre?: string;
  }>(MAT_DIALOG_DATA);

  public miCliente = LoginService.getCliente();
  title = 'Clonar';
  btnOkText = 'Clonar';
  btnCancelText = 'Cancelar';

  public idCliente?: string;

  public async clonar() {
    if (this.data.entidad === 'codigoDispositivo' && this.idCliente) {
      this.loading.setLoading(true);
      await this.codigosService.clonar(this.data.idEntidad, this.idCliente);
      this.helper.notifSuccess('Clonado correctamente');
    }
    this.loading.setLoading(false);
    this.matDialogRef.close();
  }

  async ngOnInit() {
    if (this.data.entidad === 'codigoDispositivo') {
      this.title = 'Clonar códigos';
    }
  }

  async ngOnDestroy() {}
}
